import { render, staticRenderFns } from "./AddBannerWidget.vue?vue&type=template&id=71d33d43"
import script from "./AddBannerWidget.vue?vue&type=script&lang=js"
export * from "./AddBannerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports